import { Utils } from "../core/Utils";
import { uploadFile } from "../core/uploadFile";
import { AbstractSection } from "./AbstractSection";
import { Cookie } from "../core/Cookie";
import { simpleForm } from "../core/SimpleForm";
import { MediaData } from "@ts/data/MediaData";


export class VideoSection extends AbstractSection {

    public constructor(section:MediaData) {
        super(section);
        this.renderTarget.classList.add('video-wrapper');
    }

    protected onViewRender(): void {

        const data = this.data as MediaData;
        this.renderTarget.innerHTML = Utils.minify( `
            <figure>
                <video id="video-src" src="${data.mediafile}" controls ${data.shadow?'class="shadow"':''}></video>
                <figcaption id="video-comment" >${data.comment}</figcaption>
            </figure>
            `);
        this.renderTarget.addEventListener('dblclick', (e: Event) => {
            e.preventDefault();
        });
    }

    protected onEditRender(): void {

        const data = this.data as MediaData;
        this.renderTarget.innerHTML = Utils.minify(`
                <figure>
                <video id="video-src" src="${data.mediafile}" controls ${data.shadow?'class="shadow"':''}></video>
                    <figcaption >${data.comment}</figcaption>
                </figure>
            `);

        if (this.tbar) {
            this.tbar.add('Byt video',
                'video',
                `Klicka för att byta till en annan video. Videoms storlek är begränsad till 32 MB. Den gränsen kan överskridas men då
                måste du kontakta mig <a href="mailto:roland@rstralberg.com">roland@rstralberg.com</a>`,
                () => {
                    uploadFile('video', Cookie.pagename)
                        .then((resolve: string | false) => {
                            if (resolve) {
                                const videoElement = this.renderTarget.querySelector('video') as HTMLVideoElement;
                                videoElement.src = resolve;
                                Utils.forceRefresh(videoElement);
                            }
                        });
                });
            this.tbar.add('Ändra kommentar',
                `Här kan du lägga till en kommentar. Vill du ingen ha så lämna skrivfältet tomt. Kommentaren
                kan vara fler än en rad om du så vill`,
                'comment', async () => {
                    const commentElement = this.renderTarget.querySelector('figcaption') as HTMLElement;
                    await simpleForm('Audio', 4, 'Ändra kommentar', commentElement.innerText, 'Min kommentar')
                        .then((text: string) => {
                            commentElement.innerText = text;
                            Utils.forceRefresh(commentElement);
                        });
                });
            this.tbar.add('Växla skuggning',
                'Växlar skuggning av videospelaren',
                'shadow', () => {
                    const videoElement = this.renderTarget.querySelector('video') as HTMLVideoElement;
                    Utils.toggleCss(videoElement,'shadow');
                });

        }
    };

    protected parseContent(): void {
        const video = this.renderTarget.querySelector('video') as HTMLVideoElement;
        (this.data as MediaData).mediafile = Utils.stripHost(video.src);

        const figcaption = this.renderTarget.querySelector('figcaption') as HTMLElement;
        (this.data as MediaData).comment = figcaption.innerText;

        (this.data as MediaData).shadow = video.classList.contains('shadow');
    }
}